import React, { Component } from 'react';
import {  Image } from 'semantic-ui-react';
import {  toCurrency,  } from '../../../../config/constants';
import ImageUploader from '../../../newSite/ImageUploader'

class RegularPaymentsTableCell extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            imageUrl: ''
         }
    }

    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url,
            sendImage: true
        });
        // this.props.history.push('/newOrder/thankYou');
        this.props.getImageLink(this.props.allowance.idshirTypes, url)
    }

    render() { 
        return ( 
            <div>

                {/* <Button color="teal" > Image </Button> */}

                <ImageUploader
                            updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                            storageReference={'regularpayments'} />

                <h4>{this.state.imageUrl}</h4>
                <Image src={this.state.imageUrl} size='small' />
                
                    {/* <Table.Cell> {this.props.allowance.idshirtTypesDisplay} </Table.Cell>
                    <Table.Cell positive>{this.props.allowance.shirtTypeToShow}</Table.Cell>
                    <Table.Cell error>{this.props.allowance.shirtTypeName}</Table.Cell>
                    <Table.Cell>{this.props.allowance.idshirTypes}</Table.Cell>
                    <Table.Cell>{toCurrency(this.props.allowance.shirttypebuycost)}</Table.Cell> */}
              
            </div>
         );
    }
}
 
export default RegularPaymentsTableCell;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Allowances/RegularPaymentsTableCell.js